// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__FooterMenuItem from "./FooterMenuItem.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FooterMenu(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const menus = match[0].mainMenus;
  const dropdownItems = Belt__Belt_List.keep(menus, (function (i) {
    return i.type_ === "dropdown";
  }));
  return JsxRuntime.jsxs("div", {
    children: [
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (idx, menu) {
        const Key = "menu_item_" + String(idx);
        return JsxRuntime.jsx(Buhta_landing__FooterMenuItem.make, {
          menu: menu,
          idx: idx
        }, Key);
      }), dropdownItems)),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: Buhta_landing__I18n.trans(intl, "help"),
            className: "label-medium text-gray-landing"
          }),
          JsxRuntime.jsxs("ul", {
            children: [
              JsxRuntime.jsx("li", {
                children: Buhta_landing__I18n.trans(intl, "help_center"),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta"),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Contact */ 7
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "contacts")
                }),
                className: "mt-2"
              })
            ],
            className: "paragraph-small text-gray-landing mt-5"
          })
        ],
        className: "w-57"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: Buhta_landing__I18n.trans(intl, "company"),
            className: "label-medium text-gray-landing"
          }),
          JsxRuntime.jsxs("ul", {
            children: [
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* About */ 3
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "about")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Partners */ 4
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "partners")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Pricing */ 5
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "pricing")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Contact */ 7
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "contacts")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* CompanyDetails */ 8
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "company_details")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Jobs */ 9
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "jobs")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Awards */ 10
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "awards")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Licenses */ 11
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "licenses")
                }),
                className: "mt-2"
              }),
              JsxRuntime.jsx("li", {
                children: JsxRuntime.jsx(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: {
                      TAG: /* Legal */ 7,
                      _0: /* Security */ 3
                    }
                  },
                  className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                  children: Buhta_landing__I18n.trans(intl, "legal_security")
                }),
                className: "mt-2"
              })
            ],
            className: "paragraph-small text-gray-landing mt-5"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "instagram",
                  src: StaticAsset.src("/static/icons/instagram.svg")
                }),
                href: "https://www.instagram.com/buhta.kz/",
                target: "__blank"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "linkedin",
                  src: StaticAsset.src("/static/icons/linkedin.svg")
                }),
                href: "https://www.linkedin.com/company/buhta/",
                target: "__blank"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "x",
                  src: StaticAsset.src("/static/icons/x.svg")
                }),
                href: "https://twitter.com/Buhta_kz",
                target: "__blank"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "telegram",
                  src: StaticAsset.src("/static/icons/telegram.svg")
                }),
                href: "https://t.me/buhta_kz",
                target: "__blank"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "w-6 h-6",
                  alt: "facebook",
                  src: StaticAsset.src("/static/icons/facebook.svg")
                }),
                href: "https://www.facebook.com/buhta",
                target: "__blank"
              })
            ],
            className: "flex mt-5 gap-3"
          })
        ],
        className: "w-57"
      })
    ],
    className: "flex m-auto mt-8 justify-between lg:w-252"
  });
}

const make = FooterMenu;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
